import {
  FetchVendorThemeAction,
  updateThemeCustomization,
} from "../../redux/actions/UsersAction";

import MyModal from "../../components/mymodal/myModal";

import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm, FormProvider, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Visibility from "@mui/icons-material/Visibility";
import Label from "src/components/Label";

import {
  Button,
  Container,
  Checkbox,
  FormControl,
  Grid,
  TextField,
  Typography,
  InputAdornment,
  IconButton,
  Box,
  Modal,
  Divider,
} from "@mui/material";

import Page from "src/components/Page";

const CricketCustomization = () => {
  const dispatch = useDispatch();
  const currentUser = useMemo(
    () => JSON.parse(localStorage.getItem("security_auth")) || {},
    []
  );
  const [open, setOpen] = useState(false);
  const [userData, setUserData] = useState(null);
  const [colors, setColors] = useState({
    "background_color": "#1D1D1D",
    "theme_bg_color":"#000000",
    "primary_color": "#F8D002",
    "secondary_color": "#EB6320",
    "light_secondary_color": "#F48810",
    "secondary_dark_color": "#F48810",
    "background_light": "#1E1E1E",
    "border_color": "#5D5D5D",
    "feature_box_bg": "#262626",
    "faq_border": "#343434",
    "font_primary": "#ffffff",
    "font_secondary": "#79b8f3",
    "dark_text": "#828282",
    "input_bg": "#262626",
    "contestBlock_bg": "#262626",
    "table_header": "#343434",
    "circle_color": "#4A4A4A",
    "progress_color": "#4A4A4A",
    "contest_block_bg": "#262626", 
  });


  const handleOpen = (data) => {
    setOpen(true);
    setUserData(data);
  };

  const themeUpdateRefresh = useSelector(
    (state) => state.users?.theme_update_refresh
  );
  // console.log("==============================> ", themeUpdateRefresh);

  useEffect(() => {
    if (currentUser?.id) {
      dispatch(FetchVendorThemeAction({ userid: currentUser?.id }));
    }
  }, [currentUser, dispatch, themeUpdateRefresh]);

  const UserVendorList = useSelector(
    (state) => state.users.customization_Deatils
  );
  const USERVENDORLIST = UserVendorList?.data?.data;

  const VendorColordata = USERVENDORLIST?.datachanged;
  console.log("VendorColordata-->>",VendorColordata);

  const defaultValues = useMemo(
    () => ({
      cricket: colors?.cricket || 0,
      football: colors?.football || 0,
      player_accumulator: colors?.player_accumulator || 0,
      player_contest: colors?.player_contest || 0,
      background_color: colors?.background_color || "",
      theme_bg_color:colors?.theme_bg_color || "",
      feature_box_bg: colors?.feature_box_bg || "#262626",
      background_light: colors?.background_light || "#1E1E1E",
      border_color: colors?.border_color || "#5D5D5D",
      circle_color: colors?.circle_color || "#4A4A4A",
      contest_block_bg: colors?.contest_block_bg || "#262626",
      dark_text: colors?.dark_text || "#828282",
      faq_border: colors?.faq_border || "#343434",
      font_secondary: colors?.font_secondary || "#79b8f3",
      light_secondary_color:
        colors?.light_secondary_color || "#F48810",
      primary_color: colors?.primary_color || "#F48810",
      progress_color: colors?.progress_color || "#4A4A4A",
      secondary_color: colors?.secondary_color || "#EB6320",
      secondary_dark_color: colors?.secondary_dark_color || "#F48810",
      table_header: colors?.table_header || "#343434",
      input_bg: colors?.input_bg || "#262626",
      font_primary: colors?.font_primary || "#ffffff",
    }),
    [VendorColordata]
  );

  const NewUserSchema = Yup.object().shape({
    // cricket: Yup.number()
    //   .required("Cricket is required")
    //   .typeError("Cricket must be a number"),
    // football: Yup.number()
    //   .required("Football is required")
    //   .typeError("Football must be a number"),
    // // Add other fields as necessary with the appropriate validation
  });

  const methods = useForm({
    resolver: yupResolver(NewUserSchema),
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    control,
    formState: { isSubmitting },
  } = methods;

  useEffect(() => {
    if (VendorColordata) {
      setColors(VendorColordata);
      //reset(defaultValues);
    }
  }, [VendorColordata]);//, reset, defaultValues

  const handleNewCustomizations = async (data) => {
    const excludedKeys = [
      "cricket",
      "football",
      "player_accumulator",
      "player_contest",
    ];
    const formData = new FormData();
    for (const key in colors) {
      if (!excludedKeys.includes(key)) {
        formData.append(key, colors[key]);
      }
    }
    formData.append("id", currentUser?.id?.toString());
    console.log("colorchange--->>",colors);
    dispatch(updateThemeCustomization(formData));

    // Optionally reset form after submission
    reset();
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (themeUpdateRefresh) {
          const message =
            UserVendorList?.data?.message || "Message unavailable";
          toast.success(message, { theme: "colored" });

          // setTimeout(() => {
          //   window.location.reload();
          // }, 500);
        }
      } catch (error) {
        console.error("Error in useEffect:", error);
        toast.error("Error fetching data", { theme: "colored" });
      }
    };

    fetchData();
  }, [themeUpdateRefresh, UserVendorList?.data?.message]); // Depend on UserVendorList directly, not UserVendorList?.data?.status

  // console.log(UserVendorList);
  // Initialize useForm

  const handleClose = () => {
    setOpen(false); // Close modal
    setUserData(null);
  };

  const handleColorChange = (key, value) => {
    console.log("colors--->>",key, value);
    setColors((prev) => ({ ...prev, [key]: value }));
    
  };

  return (
    <div>
      <Page title="Theme Customization">
        <Container maxWidth="xl">
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(handleNewCustomizations)}>
              <Typography variant="h6" component="h1">
                Sports Customization
              </Typography>
              <Grid container spacing={2}>
                <Grid item md={3}>
                  <FormControl fullWidth>
                    <Typography
                      variant="subtitle1"
                      component="h1"
                      paddingTop={"10px"}
                    >
                      Cricket {" : "}
                      {VendorColordata?.cricket ? (
                        <Label variant="ghost" color="success">
                          Enable
                        </Label>
                      ) : (
                        <Label variant="ghost" color="error">
                          Disable
                        </Label>
                      )}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item md={3}>
                  <FormControl fullWidth>
                    <Typography
                      variant="subtitle1"
                      component="h1"
                      paddingTop={"10px"}
                    >
                      Football : {"  "}
                      {VendorColordata?.football ? (
                        <Label variant="ghost" color="success">
                          Enable
                        </Label>
                      ) : (
                        <Label variant="ghost" color="error">
                          Disable
                        </Label>
                      )}
                    </Typography>
                  </FormControl>
                </Grid>
              </Grid>
              <br />
              <Typography variant="h6" component="h1" paddingTop={"10px"}>
                Games Customization
              </Typography>
              <Grid container spacing={2}>
                <Grid item md={3}>
                  <FormControl fullWidth>
                    <Typography
                      variant="subtitle1"
                      component="h1"
                      paddingTop={"10px"}
                    >
                      Player Accumulator :{" "}
                      {VendorColordata?.player_accumulator ? (
                        <Label variant="ghost" color="success">
                          Enable
                        </Label>
                      ) : (
                        <Label variant="ghost" color="error">
                          Disable
                        </Label>
                      )}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item md={3}>
                  <FormControl fullWidth>
                    <Typography
                      variant="subtitle1"
                      component="h1"
                      paddingTop={"10px"}
                    >
                      {/* <Controller
                        name="player_contest"
                        control={control}
                        render={({ field }) => (
                          <Checkbox
                            {...field}
                            checked={Boolean(field.value)}
                            onChange={(e) =>
                              field.onChange(e.target.checked ? 1 : 0)
                            }
                          />
                        )}
                      />{" "} */}
                      Player Contest :{" "}
                      {VendorColordata?.player_contest ? (
                        <Label variant="ghost" color="success">
                          Enable
                        </Label>
                      ) : (
                        <Label variant="ghost" color="error">
                          Disable
                        </Label>
                      )}
                    </Typography>
                  </FormControl>
                </Grid>
              </Grid>
              <br />
              <Typography
                id="modal-modal-title"
                style={{ marginBottom: 20 }}
                variant="h6"
                component="h2"
              >
                Theme Customization
              </Typography>
              <Grid container spacing={2}>
                <Grid item md={3}>
                  <FormControl fullWidth>
                    <Controller
                      name="theme_bg_color"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          value={colors["theme_bg_color"]}
                          onChange={(e) => handleColorChange("theme_bg_color", e.target.value)}
                          label="Theme Background Color"
                          variant="outlined"
                          placeholder="theme_bg_color: #000000;"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <input type="color" 
                                value={colors["theme_bg_color"]} 
                                onChange={(e) => handleColorChange("theme_bg_color", e.target.value)} 
                                />
                                <IconButton
                                  aria-label="toggle text visibility"
                                  onClick={() => handleOpen("background-color")}
                                  // onClick={handleOpen}
                                  edge="end"
                                >
                                  <Visibility />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={3}>
                  <FormControl fullWidth>
                    <Controller
                      name="background_color"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          value={colors["background_color"]}
                          onChange={(e) => handleColorChange("background_color", e.target.value)}
                          label="Background Color"
                          variant="outlined"
                          placeholder="background-color: #1D1D1D;"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <input type="color" 
                                value={colors["background_color"]} 
                                onChange={(e) => handleColorChange("background_color", e.target.value)} 
                                />
                                <IconButton
                                  aria-label="toggle text visibility"
                                  onClick={() => handleOpen("background-color")}
                                  // onClick={handleOpen}
                                  edge="end"
                                >
                                  <Visibility />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={3}>
                  <FormControl fullWidth>
                    <Controller
                      name="primary_color"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          value={colors["primary_color"]}
                          onChange={(e) => handleColorChange("primary_color", e.target.value)}
                          label="Primary Color"
                          variant="outlined"
                          placeholder="primary-color: #F8D002;"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <input type="color" 
                                value={colors["primary_color"]} 
                                onChange={(e) => handleColorChange("primary_color", e.target.value)} 
                                />
                                <IconButton
                                  aria-label="toggle text visibility"
                                  onClick={() => handleOpen("primary-color")}
                                  edge="end"
                                >
                                  <Visibility />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={3}>
                  <FormControl fullWidth>
                    <Controller
                      name="secondary_color"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          value={colors["secondary_color"]}
                          onChange={(e) => handleColorChange("secondary_color", e.target.value)}
                          label="Secondary Color"
                          variant="outlined"
                          placeholder="secondary-color: #EB6320;"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <input type="color" 
                                value={colors["secondary_color"]} 
                                onChange={(e) => handleColorChange("secondary_color", e.target.value)} 
                                />
                                <IconButton
                                  aria-label="toggle text visibility"
                                  onClick={() => handleOpen("secondary-color")}
                                  edge="end"
                                >
                                  <Visibility />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={3}>
                  <FormControl fullWidth>
                    <Controller
                      name="light_secondary_color"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          value={colors["light_secondary_color"]}
                          onChange={(e) => handleColorChange("light_secondary_color",e.target.value)}
                          label="Light Secondary Color"
                          variant="outlined"
                          placeholder="light-secondary-color: #F48810;"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <input type="color" 
                                value={colors["light_secondary_color"]} 
                                onChange={(e) => handleColorChange("light_secondary_color", e.target.value)} 
                                />
                                <IconButton
                                  aria-label="toggle text visibility"
                                  onClick={() =>
                                    handleOpen("light-secondary-color")
                                  }
                                  edge="end"
                                >
                                  <Visibility />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={3}>
                  <FormControl fullWidth>
                    <Controller
                      name="secondary_dark_color"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          value={colors["secondary_dark_color"]}
                          onChange={(e) => handleColorChange("secondary_dark_color", e.target.value)}
                          label="Secondary Dark Color"
                          variant="outlined"
                          placeholder="secondary-dark-color: #F48810;"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <input type="color" 
                                value={colors["secondary_dark_color"]} 
                                onChange={(e) => handleColorChange("secondary_dark_color", e.target.value)} 
                                />
                                <IconButton
                                  aria-label="toggle text visibility"
                                  onClick={() =>
                                    handleOpen("secondary-dark-color")
                                  } // Add click handler
                                  edge="end"
                                >
                                  <Visibility />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={3}>
                  <FormControl fullWidth>
                    <Controller
                      name="background_light"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          value={colors["background_light"]}
                          onChange={(e) => handleColorChange("background_light", e.target.value)}
                          label="Background Light"
                          variant="outlined"
                          placeholder="background-light: #1E1E1E;"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <input type="color" 
                                value={colors["background_light"]} 
                                onChange={(e) => handleColorChange("background_light", e.target.value)} 
                                />
                                <IconButton
                                  aria-label="toggle text visibility"
                                  onClick={() => handleOpen("background-light")} // Add click handler // Add click handler
                                  edge="end"
                                >
                                  <Visibility />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={3}>
                  <FormControl fullWidth>
                    <Controller
                      name="border_color"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          value={colors["border_color"]}
                          onChange={(e) => handleColorChange("border_color", e.target.value)}
                          label="Border Color"
                          variant="outlined"
                          placeholder="border-color: #5D5D5D;"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <input type="color" 
                                value={colors["border_color"]} 
                                onChange={(e) => handleColorChange("border_color", e.target.value)} 
                                />
                                <IconButton
                                  aria-label="toggle text visibility"
                                  onClick={() => handleOpen("border-color")}
                                  edge="end"
                                >
                                  <Visibility />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={3}>
                  <FormControl fullWidth>
                    <Controller
                      name="feature_box_bg"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          value={colors["feature_box_bg"]}
                          onChange={(e) => handleColorChange("feature_box_bg", e.target.value)}
                          label="Feature Box Bg"
                          variant="outlined"
                          placeholder="feature-box-bg: #262626;"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <input type="color" 
                                value={colors["feature_box_bg"]} 
                                onChange={(e) => handleColorChange("feature_box_bg", e.target.value)} 
                                />
                                <IconButton
                                  aria-label="toggle text visibility"
                                  onClick={() => handleOpen("feature-box-bg")}
                                  edge="end"
                                >
                                  <Visibility />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={3}>
                  <FormControl fullWidth>
                    <Controller
                      name="faq_border"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          value={colors["faq_border"]}
                          onChange={(e) => handleColorChange("faq_border", e.target.value)}
                          label="Faq Border"
                          variant="outlined"
                          placeholder="faq-border: #343434;"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <input type="color" 
                                value={colors["faq_border"]} 
                                onChange={(e) => handleColorChange("faq_border", e.target.value)} 
                                />
                                <IconButton
                                  aria-label="toggle text visibility"
                                  onClick={() => handleOpen("faq-border")}
                                  edge="end"
                                >
                                  <Visibility />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={3}>
                  <FormControl fullWidth>
                    <Controller
                      name="font_primary"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          value={colors["font_primary"]}
                          onChange={(e) => handleColorChange("font_primary", e.target.value)}
                          label="Font Primary"
                          variant="outlined"
                          placeholder="font-primary: #ffffff;"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <input type="color" 
                                value={colors["font_primary"]} 
                                onChange={(e) => handleColorChange("font_primary", e.target.value)} 
                                />
                                <IconButton
                                  aria-label="toggle text visibility"
                                  onClick={() => handleOpen("font-primary")}
                                  edge="end"
                                >
                                  <Visibility />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={3}>
                  <FormControl fullWidth>
                    <Controller
                      name="font_secondary"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          value={colors["font_secondary"]}
                          onChange={(e) => handleColorChange("font_secondary", e.target.value)}
                          label="Font Secondary"
                          variant="outlined"
                          placeholder="font-secondary: #79b8f3;"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <input type="color" 
                                value={colors["font_secondary"]} 
                                onChange={(e) => handleColorChange("font_secondary", e.target.value)} 
                                />
                                <IconButton
                                  aria-label="toggle text visibility"
                                  onClick={() => handleOpen("font-secondary")}
                                  edge="end"
                                >
                                  <Visibility />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={3}>
                  <FormControl fullWidth>
                    <Controller
                      name="dark_text"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          value={colors["dark_text"]}
                          onChange={(e) => handleColorChange("dark_text", e.target.value)}
                          label="Dark Text"
                          variant="outlined"
                          placeholder="dark-text: #828282;"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <input type="color" 
                                value={colors["dark_text"]} 
                                onChange={(e) => handleColorChange("dark_text", e.target.value)} 
                                />
                                <IconButton
                                  aria-label="toggle text visibility"
                                  onClick={() => handleOpen("dark-text")}
                                  edge="end"
                                >
                                  <Visibility />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={3}>
                  <FormControl fullWidth>
                    <Controller
                      name="input_bg"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          value={colors["input_bg"]}
                          onChange={(e) => handleColorChange("input_bg", e.target.value)}
                          label="Input Bg"
                          variant="outlined"
                          placeholder="input-bg: #262626;"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <input type="color" 
                                value={colors["input_bg"]} 
                                onChange={(e) => handleColorChange("input_bg", e.target.value)} 
                                />
                                <IconButton
                                  aria-label="toggle text visibility"
                                  onClick={() => handleOpen("input-bg")} // Add click handler
                                  edge="end"
                                >
                                  <Visibility />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={3}>
                  <FormControl fullWidth>
                    <Controller
                      name="contest_block_bg"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          value={colors["contest_block_bg"]}
                          onChange={(e) => handleColorChange("contest_block_bg", e.target.value)}
                          label="Contest Block Bg"
                          variant="outlined"
                          placeholder="contestBlock-bg: #262626;"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <input type="color" 
                                value={colors["contest_block_bg"]} 
                                onChange={(e) => handleColorChange("contest_block_bg", e.target.value)} 
                                />
                                <IconButton
                                  aria-label="toggle text visibility"
                                  onClick={() => handleOpen("contestBlock-bg")}
                                  edge="end"
                                >
                                  <Visibility />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={3}>
                  <FormControl fullWidth>
                    <Controller
                      name="table_header"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          value={colors["table_header"]}
                          onChange={(e) => handleColorChange("table_header", e.target.value)}
                          label="Table Header"
                          variant="outlined"
                          placeholder="table-header: #343434;"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <input type="color" 
                                value={colors["table_header"]} 
                                onChange={(e) => handleColorChange("table_header", e.target.value)} 
                                />
                                <IconButton
                                  aria-label="toggle text visibility"
                                  onClick={() => handleOpen("table-header")}
                                  edge="end"
                                >
                                  <Visibility />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={3}>
                  <FormControl fullWidth>
                    <Controller
                      name="circle_color"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          value={colors["circle_color"]}
                          onChange={(e) => handleColorChange("circle_color", e.target.value)}
                          label="Circle Color"
                          variant="outlined"
                          placeholder="circle-color: #4A4A4A;"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <input type="color" 
                                value={colors["circle_color"]} 
                                onChange={(e) => handleColorChange("circle_color", e.target.value)} 
                                />
                                <IconButton
                                  aria-label="toggle text visibility"
                                  onClick={() => handleOpen("circle-color")}
                                  edge="end"
                                >
                                  <Visibility />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={3}>
                  <FormControl fullWidth>
                    <Controller
                      name="progress_color"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          value={colors["progress_color"]}
                          onChange={(e) => handleColorChange("progress_color", e.target.value)}
                          label="Progress Color"
                          variant="outlined"
                          placeholder="progress-color: #4A4A4A;"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <input type="color" 
                                value={colors["progress_color"]} 
                                onChange={(e) => handleColorChange("progress_color", e.target.value)} 
                                />
                                <IconButton
                                  aria-label="toggle text visibility"
                                  onClick={() => handleOpen("progress-color")}
                                  edge="end"
                                >
                                  <Visibility />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid
                  item
                  md={3}
                  style={{
                    textAlign: "left",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Button
                    size="large"
                    color="primary"
                    variant="contained"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </form>
          </FormProvider>
          {/* <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            size="lg"
          >
            <Box sx={style}>
              <IconButton onClick={handleClose} style={closeButtonStyle}>
                <CloseIcon />
              </IconButton>
              <Typography
                id="modal-modal-title"
                style={{ marginBottom: 20 }}
                align={"center"}
                variant="h6"
                component="h2"
              >
                {userData}
              </Typography>
              <Divider />
            </Box>
          </Modal> */}
          <MyModal open={open} onClose={handleClose} userData={userData} />
        </Container>
      </Page>
    </div>
  );
};

export default CricketCustomization;
